module.exports = __webpack_public_path__ + "img/1-1_07.ec331827.jpg";